import {
  buildLocationMarkersJson,
  buildOpenStreetMapLink,
  formatBytes,
  formatDate,
  renderMarkdown,
  rewriteTelegramMessageLinks,
} from "../lib/format.js";

<const/pageData=$global.messagePageData || null>
<const/message=pageData ? pageData.message : null>
<const/mediaItems=pageData ? pageData.mediaItems : []>
<const/locationItems=pageData ? pageData.locationItems : []>
<const/locationMapItems=locationItems.map((location) => ({
  ...location,
  mapLink: buildOpenStreetMapLink(location.latitude, location.longitude),
})).filter((location) => location.mapLink)>
<const/hasLocationMapItems=Boolean(locationMapItems.length)>

<link rel="stylesheet" href="https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.css">

<main class="entry-page">
  <header class="masthead">
    <h1>Vahid Online in English</h1>
    <p class="deck">
      Automated AI translations of Vahid Online reporting. Exported from the
      <a href="https://t.me/VahidOnline" target="_blank" rel="noreferrer">Telegram Channel</a>.
      Original content also available on
      <a href="https://x.com/Vahid/" target="_blank" rel="noreferrer">X/Twitter</a>.
    </p>
  </header>

  <a class="back" href="/">← Back to latest feed</a>

  <if=message>
    <const/originalText=message.text || message.raw_text || "">
    <const/englishText=(message.translation_status === "translated" && message.translated_text)
      ? message.translated_text
      : "">
    <const/hasEnglishTranslation=Boolean(englishText)>
    <const/renderedEnglishHtml=hasEnglishTranslation
      ? rewriteTelegramMessageLinks(renderMarkdown(englishText), {
          chatId: message.chat_id,
        })
      : "">
    <const/renderedOriginalHtml=rewriteTelegramMessageLinks(renderMarkdown(originalText), {
      chatId: message.chat_id,
    })>
    <const/replyTargetId=message.reply_to_msg_id_extracted || message.reply_to_msg_id>
    <const/hasLocalReplyTarget=Boolean(pageData && pageData.hasLocalReplyTarget)>
    <const/replyHref=hasLocalReplyTarget ? `/messages/${message.chat_id}/${replyTargetId}` : null>
    <const/fwdChannelId=message.fwd_channel_id>
    <const/fwdChannelPost=message.fwd_channel_post>
    <const/fwdLabel=message.fwd_from_name || (fwdChannelId ? `channel ${fwdChannelId}` : null)>
    <const/fwdHref=(fwdChannelId && fwdChannelPost)
      ? `https://t.me/c/${String(fwdChannelId).startsWith("100") ? String(fwdChannelId).slice(3) : String(fwdChannelId)}/${fwdChannelPost}`
      : null>
    <const/entryClass=["entry", "panel", fwdLabel ? "is-forwarded" : ""].filter(Boolean).join(" ")>

    <article class=entryClass data-message-card>
      <header>
        <p class="stamp">
          <span>${formatDate(message.date_utc)}</span>
          <if=hasEnglishTranslation>
            <button type="button" class="stamp-view-toggle" data-message-toggle aria-pressed="false">
              •
              <span data-message-toggle-label>show original</span>
            </button>
          </if>
        </p>
      </header>

      <if=fwdLabel>
        <p class="context-note forwarded-note">
          Forwarded from
          <if=fwdHref>
            <a href=fwdHref target="_blank" rel="noreferrer">${fwdLabel}</a>
          </if>
          <else>${fwdLabel}</else>
        </p>
      </if>

      <if=replyTargetId>
        <p class="context-note">
          Replying to
          <if=replyHref>
            <a href=replyHref>message #${replyTargetId}</a>
          </if>
          <else>message #${replyTargetId}</else>
        </p>
      </if>

      <if=message.reply_quote_text>
        <blockquote class="embedded-quote">${message.reply_quote_text}</blockquote>
      </if>

      <if=hasEnglishTranslation>
        <div class=(fwdLabel ? "body forwarded-body" : "body") data-body-variant="english">$!{renderedEnglishHtml}</div>
        <div class=(fwdLabel ? "body forwarded-body" : "body") data-body-variant="original" hidden>$!{renderedOriginalHtml}</div>
      </if>
      <else>
        <if=originalText>
          <div class=(fwdLabel ? "body forwarded-body" : "body")>$!{renderedOriginalHtml}</div>
          <p class="translation-note">English translation not available yet — showing original text.</p>
        </if>
        <else>
          <p class="body muted">No text body attached to this post.</p>
        </else>
      </else>

      <if=message.has_media>
        <if=mediaItems.length>
          <section class="media-gallery" data-gl>
            <h2>${message.grouped_id && mediaItems.length > 1 ? `Album media (${mediaItems.length} items)` : "Attached media"}</h2>

            <for|item| of=mediaItems>
              <const/mediaHref=`/api/media/${item.chat_id}/${item.message_id}`>
              <const/isVideo=item.media_type === "video" || (item.media_mime_type && item.media_mime_type.startsWith("video/"))>
              <const/isImage=item.media_type === "photo" || (item.media_mime_type && item.media_mime_type.startsWith("image/"))>
              <const/isAudio=item.media_type === "voice" || (item.media_mime_type && item.media_mime_type.startsWith("audio/"))>
              <const/downloaded=item.media_download_status === "downloaded">

              <figure class="media-item">
                <if=downloaded>
                  <if=isVideo>
                    <button type="button" class="gl-thumb" data-gl-item data-gl-src=mediaHref data-gl-type="video">
                      <video preload="metadata" src=`${mediaHref}#t=0.1` muted playsinline></video>
                      <span class="gl-play" aria-hidden="true"></span>
                    </button>
                  </if>
                  <else>
                    <if=isImage>
                      <button type="button" class="gl-thumb" data-gl-item data-gl-src=mediaHref data-gl-type="image">
                        <img src=mediaHref alt=`Media ${item.message_id}` loading="lazy">
                      </button>
                    </if>
                    <else>
                      <if=isAudio>
                        <audio controls preload="metadata" src=mediaHref></audio>
                      </if>
                      <else>
                        <a class="download-link" href=mediaHref target="_blank" rel="noreferrer">Open downloaded file</a>
                      </else>
                    </else>
                  </else>
                </if>
                <else>
                  <div class="pending-media-frame">pending</div>
                </else>

                <figcaption>
                  #${item.message_id}
                  <if=item.media_mime_type> · ${item.media_mime_type}</if>
                  <if=item.media_size_bytes> · ${formatBytes(item.media_size_bytes)}</if>
                </figcaption>
              </figure>
            </for>
          </section>
        </if>
      </if>

      <if=hasLocationMapItems>
        <const/locationMarkersJson=buildLocationMarkersJson(locationMapItems)>
        <section class="entry-map">
          <h2>Mapped locations (${locationMapItems.length})</h2>
          <div
            class="entry-map-frame"
            data-maplibre-map
            data-markers=locationMarkersJson

            data-interactive="true"
            data-map-label=`Location map for message ${message.message_id}`>
          </div>
          <p class="entry-map-attrib">Map data © OpenStreetMap contributors</p>
        </section>
      </if>
    </article>

  </if>
  <else>
    <section class="panel">
      <h1>Message not found</h1>
      <if=$global.messagePageError>
        <p>Sorry, this post is unavailable right now. Please try again in a bit.</p>
      </if>
      <else>
        <p>This post isn't available in the archive.</p>
      </else>
    </section>
  </else>
</main>

<script>
  (function () {
    const MAPLIBRE_URL = "https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.js";

    function toggleMessageLanguage(event) {
      const toggle = event.target.closest("[data-message-toggle]");
      if (!toggle) return;

      const card = toggle.closest("[data-message-card]");
      if (!card) return;

      const englishBody = card.querySelector('[data-body-variant="english"]');
      const originalBody = card.querySelector('[data-body-variant="original"]');
      if (!englishBody || !originalBody) return;

      const showingEnglish = !englishBody.hidden;
      englishBody.hidden = showingEnglish;
      originalBody.hidden = !showingEnglish;

      toggle.setAttribute("aria-pressed", showingEnglish ? "true" : "false");

      const label = toggle.querySelector("[data-message-toggle-label]");
      if (label) {
        label.textContent = showingEnglish ? "show english" : "show original";
      }
    }

    function createMap(element) {
      if (element.dataset.mapReady === "true") return;

      const markersJson = element.dataset.markers || "";
      let markers = [];
      if (markersJson) {
        try {
          const parsed = JSON.parse(markersJson);
          if (Array.isArray(parsed)) {
            markers = parsed
              .map((marker, index) => {
                const north = Number(marker?.bounds?.north);
                const east = Number(marker?.bounds?.east);
                const south = Number(marker?.bounds?.south);
                const west = Number(marker?.bounds?.west);
                const bounds = [north, east, south, west].every(Number.isFinite)
                  ? { north, east, south, west }
                  : null;

                return {
                  lat: Number(marker?.lat),
                  lon: Number(marker?.lon),
                  label: marker?.label || `Location ${index + 1}`,
                  link: marker?.link || null,
                  precision: marker?.precision || null,
                  locationType: marker?.locationType || null,
                  bounds,
                };
              })
              .filter((marker) => Number.isFinite(marker.lat) && Number.isFinite(marker.lon));
          }
        } catch {
          markers = [];
        }
      }

      if (!markers.length) {
        const lat = Number.parseFloat(element.dataset.lat || "");
        const lon = Number.parseFloat(element.dataset.lon || "");
        if (Number.isFinite(lat) && Number.isFinite(lon)) {
          markers = [{ lat, lon, label: "Location", link: null }];
        }
      }

      if (!markers.length) return;

      const interactive = element.dataset.interactive === "true";

      function zoomForMarker(marker) {
        const p = (marker.precision || "").toLowerCase();
        const t = (marker.locationType || "").toLowerCase();
        const label = (marker.label || "").toLowerCase();

        if (p === "country" || t === "country") return 5;
        if (p === "province" || t === "province" || t === "region") return 7;
        if (/\bstrait\b|\bgulf\b|\bsea\b|\bocean\b|\blake\b|\briver\b|\bmountain\b/.test(label)) return 8;
        if (p === "city" || t === "city") return 11;
        if (p === "district" || t === "district" || t === "neighborhood") return 13;
        if (t === "street" || t === "intersection") return 14;
        if (p === "exact" || t === "facility" || t === "airport" || t === "military base"
            || t === "specific" || t === "specific place" || t === "complex"
            || t === "organization" || t === "base" || t === "coordinates") return 13;
        if (p === "unknown" || p === "") return 10;
        return 11;
      }

      const initialZoom = markers.length === 1 ? zoomForMarker(markers[0]) : 11;

      const map = new window.maplibregl.Map({
        container: element,
        style: {
          version: 8,
          sources: {
            osm: {
              type: "raster",
              tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
              tileSize: 256,
            },
          },
          layers: [{ id: "osm", type: "raster", source: "osm" }],
        },
        center: [markers[0].lon, markers[0].lat],
        zoom: initialZoom,
        attributionControl: false,
        interactive,
      });

      if (interactive) {
        map.addControl(new window.maplibregl.NavigationControl({ showCompass: false }), "top-right");
      }

      const bounds = new window.maplibregl.LngLatBounds();
      markers.forEach((marker, index) => {
        const popupContent = document.createElement("div");
        popupContent.className = "map-popup";

        const title = document.createElement("strong");
        title.textContent = marker.label;
        popupContent.appendChild(title);

        if (marker.link) {
          const line = document.createElement("div");
          const link = document.createElement("a");
          link.href = marker.link;
          link.target = "_blank";
          link.rel = "noreferrer";
          link.textContent = "Open map";
          line.appendChild(link);
          popupContent.appendChild(line);
        }

        const popup = new window.maplibregl.Popup({ offset: 16, closeButton: false }).setDOMContent(popupContent);

        new window.maplibregl.Marker({ color: "#3b82f6" })
          .setLngLat([marker.lon, marker.lat])
          .setPopup(popup)
          .addTo(map);

        bounds.extend([marker.lon, marker.lat]);
      });

      if (markers.length > 1) {
        map.fitBounds(bounds, {
          padding: 44,
          maxZoom: 14,
          duration: 0,
        });
      } else if (markers[0].bounds) {
        const markerBounds = new window.maplibregl.LngLatBounds(
          [markers[0].bounds.west, markers[0].bounds.south],
          [markers[0].bounds.east, markers[0].bounds.north],
        );
        map.fitBounds(markerBounds, {
          padding: 44,
          maxZoom: 13,
          duration: 0,
        });
      }

      map.once("load", () => map.resize());
      element.dataset.mapReady = "true";
    }

    function ensureMapLibreLoaded(callback) {
      if (window.maplibregl) {
        callback();
        return;
      }

      const existingScript = document.querySelector("script[data-maplibre-loader]");
      if (existingScript) {
        existingScript.addEventListener("load", callback, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = MAPLIBRE_URL;
      script.async = true;
      script.dataset.maplibreLoader = "true";
      script.addEventListener("load", callback, { once: true });
      document.head.appendChild(script);
    }

    function initMaps() {
      const elements = Array.from(document.querySelectorAll("[data-maplibre-map]"));
      if (!elements.length) return;

      ensureMapLibreLoaded(() => {
        elements.forEach(createMap);
      });
    }

    document.addEventListener("click", toggleMessageLanguage);
    initMaps();
  })();
</script>

<style>
  .entry-page {
    --content-inset: 1rem;
    max-width: 900px;
    margin: 0 auto;
    padding: 1.4rem 1rem 2.4rem;
    display: grid;
    gap: 1rem;
  }

  .masthead {
    border-bottom: 2px solid var(--rule);
    padding: 0 var(--content-inset) 0.9rem;
    margin-bottom: 0.15rem;
  }

  .masthead h1 {
    margin: 0.2rem 0 0;
    font-size: clamp(1.6rem, 3.4vw, 2.4rem);
    font-family: "Source Serif 4", serif;
    font-weight: 600;
  }

  .deck {
    margin: 0.45rem 0 0;
    color: var(--muted);
    max-width: 70ch;
  }

  .back {
    display: inline-block;
    padding: 0 var(--content-inset);
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.82rem;
    text-decoration: none;
  }

  .panel {
    background: var(--paper);
    border: 1px solid var(--rule);
    padding: 1rem var(--content-inset);
  }

  .entry header {
    border-bottom: 1px solid var(--rule);
    padding-bottom: 0.65rem;
    margin-bottom: 0.7rem;
  }

  .entry.is-forwarded {
    border-left-width: 4px;
    border-left-color: #d7cfbf;
  }

  .stamp {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.12rem;
    flex-wrap: wrap;
    font-family: "IBM Plex Mono", monospace;
    color: var(--muted);
    font-size: 0.76rem;
  }

  .stamp-view-toggle {
    border: 0;
    background: transparent;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 0.1rem;
    color: #9b9487;
    font-size: 0.72rem;
    font-family: inherit;
    white-space: nowrap;
    cursor: pointer;
  }

  .stamp-view-toggle:hover {
    color: #7f786c;
    text-decoration: underline;
  }

  .body {
    margin: 0;
    line-height: 1.58;
    font-family: "Source Serif 4", serif;
    font-size: 1.13rem;
    overflow-wrap: anywhere;
  }

  .body :where(p, ul, ol, blockquote, pre) {
    margin: 0 0 0.75rem;
  }

  .body :where(p:last-child, ul:last-child, ol:last-child, blockquote:last-child, pre:last-child) {
    margin-bottom: 0;
  }

  .body pre {
    background: #f6f2ea;
    border: 1px solid var(--rule);
    padding: 0.7rem;
    overflow: auto;
    font-size: 0.88rem;
    line-height: 1.44;
  }

  .body code {
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.88em;
  }

  .body blockquote {
    border-left: 3px solid var(--rule);
    padding-left: 0.7rem;
    color: var(--muted);
  }

  .muted {
    color: var(--muted);
    font-style: italic;
  }

  .context-note {
    margin: 0 0 0.5rem;
    color: var(--muted);
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.76rem;
  }

  .forwarded-note {
    margin-bottom: 0.35rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-size: 0.71rem;
  }

  .forwarded-body {
    background: #f8f4eb;
    border: 1px solid #e6ddcd;
    padding: 0.68rem 0.8rem;
  }

  .embedded-quote {
    margin: 0 0 0.75rem;
    padding: 0.55rem 0.7rem;
    border-left: 3px solid var(--rule);
    background: #f7f4ee;
    color: #3d3932;
    line-height: 1.45;
  }

  .translation-note {
    margin: 0.5rem 0 0;
    color: var(--muted);
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.76rem;
  }

  .entry-map {
    margin-top: 1rem;
    border: 1px solid var(--rule);
    padding: 0.6rem;
    background: #fff;
    width: 100%;
    display: grid;
    gap: 0.65rem;
  }

  .entry-map-frame :global(.maplibregl-popup-content) {
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.72rem;
    padding: 0.42rem 0.48rem;
  }

  .entry-map-frame :global(.map-popup) {
    display: grid;
    gap: 0.18rem;
  }
  .entry-map h2 {
    margin: 0 0 0.45rem;
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.82rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--muted);
  }

  .entry-map-frame {
    width: 100%;
    height: clamp(320px, 56vh, 560px);
    border: 0;
    display: block;
  }

  .entry-map-attrib {
    margin: 0.45rem 0 0;
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.68rem;
    color: #9f988a;
  }

  .media-gallery {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0.8rem;
    align-items: start;
  }

  .media-gallery h2 {
    margin: 0;
    grid-column: 1 / -1;
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.84rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--muted);
  }

  .media-item {
    margin: 0;
    border: 1px solid var(--rule);
    background: #fff;
    padding: 0.5rem;
    display: grid;
    gap: 0.45rem;
  }

  .media-direct-link {
    display: block;
    text-decoration: none;
  }

  .media-item video,
  .media-item img {
    width: 100%;
    max-width: 100%;
    border: 1px solid var(--rule);
    display: block;
    background: #000;
    cursor: pointer;
  }

  .media-item audio {
    width: 100%;
    cursor: pointer;
  }

  .media-item figcaption {
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.74rem;
    color: var(--muted);
  }

  .download-link {
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.77rem;
  }

  .pending-media-frame {
    width: 100%;
    min-height: 220px;
    border: 1px dashed var(--rule);
    background: #f8f5ef;
    display: grid;
    place-items: center;
    color: var(--muted);
    font-family: "IBM Plex Mono", monospace;
    font-size: 0.82rem;
    text-transform: lowercase;
  }

</style>
